import VState from 'signal/v-state'

const valuesAnchor = new VState(null)
valuesAnchor.set = valuesAnchor.set.bind(valuesAnchor)

export default valuesAnchor